export default function initVideoModal() {
  // Find all video thumbnails
  const videoThumbnails = document.querySelectorAll(".video-thumbnail");

  // Add click event to each thumbnail
  videoThumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      const modalId = this.getAttribute("data-modal-id");
      const modal = document.getElementById(modalId);
      const videoId = this.getAttribute("data-video-id");
      const videoFile = this.getAttribute("data-video-file");

      let mediaElement = "";

      if (videoId && videoId !== "") {
        // YouTube video
        mediaElement = `<iframe width="100%" height="100%" 
        src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&controls=1&showinfo=0&fs=1&color=white&disablekb=1&iv_load_policy=3" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen></iframe>`;
      } else if (videoFile && videoFile !== "") {
        // Local video file
        mediaElement = `<video width="100%" height="100%" controls autoplay>
        <source src="${videoFile}" type="video/mp4">
        Your browser does not support the video tag.
        </video>`;
      }

      // Insert media element into modal
      modal.querySelector(".video-container").innerHTML = mediaElement;

      // Show modal
      document.body.classList.add("modal-open");
      modal.style.display = "flex";
    });
  });

  // Close modal functionality
  const closeButtons = document.querySelectorAll(".close-modal");
  closeButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const modal = this.closest(".video-modal");
      document.body.classList.remove("modal-open");

      modal.style.display = "none";

      // Remove media element when closing modal
      modal.querySelector(".video-container").innerHTML = "";
    });
  });

  // Close modal when clicking outside content
  window.addEventListener("click", function (event) {
    if (event.target.classList.contains("video-modal")) {
      event.target.style.display = "none";
      event.target.querySelector(".video-container").innerHTML = "";
      document.body.classList.remove("modal-open");
    }
  });
}
